export default __webpack_public_path__ + "static/253-8e57deaace7b8a2cfe03f0ed554ad119.gif";